import React from "react"
import DOMPurify from "isomorphic-dompurify"
import { internalLinkPath } from "@/constants"
import { pureText } from "@/components/Shared/HeaderNavTabs/utils"

const externalicon = "/icons/externalicon.svg"
const externalIconWhite = "/icons/external link.svg"

const MenuItem = props => {
  const {
    getInternalLinkURLS = () => {},
    itemLink = "",
    itemLabel = "",
    darkThemeFlag = false,
    selectedTab = "",
    groupTitle = "",
    servicesAnalyticsClick = () => {},
  } = props ?? {}

  return (
    <li
      key={itemLabel + itemLink}
      className="nav-item"
      data-nav-parent={pureText(groupTitle)}
    >
      <a
        href={itemLink?.split(internalLinkPath).join("").replace(".html", "")}
        onClick={() =>
          servicesAnalyticsClick({
            text: itemLabel,
            link: itemLink,
            Leveltwo: groupTitle,
            L1: selectedTab,
          })
        }
      >
        <span
          className="menu-labels"
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(itemLabel),
          }}
        />
        {getInternalLinkURLS(itemLink) ? (
          <div className="navigation-external-img">
            <img
              src={darkThemeFlag ? externalIconWhite : externalicon}
              alt="external-icon"
            />
          </div>
        ) : null}
      </a>
    </li>
  )
}
export default MenuItem
